/**
 * DateToolbar — 사용자PC(/u/orders) 상단 검색툴바의 기간 프리셋 + 달력 팝업.
 *
 * 레거시와의 관계
 * ───────────────
 * 기존 public/js/u-order-list.js 의 calanderWinPop / popUp_InitNoticeGet / popExistsCheck /
 * getDateValue / getStatusofPopup / setTimeToAll / setTimeTo / lastSetDodate (+ popupOK) 를 이관했다.
 *   - setTimeTo/setTimeToAll/lastSetDodate : 한달·두달·전체 등 기간 프리셋 → search()
 *   - calanderWinPop                       : 관리 팝업창(/u/main) 오픈
 *   - getDateValue/getStatusofPopup/popUp_InitNoticeGet : 팝업창이 opener 로 콜백하는 진입점
 *
 * 구조: ListRender 와 동일하게 "모듈 스코프 자유함수 + 브리지 클래스".
 *   - 내부 호출(setTimeTo)·외부 전역 읽기(search/swalert/get_YYYYMMDDHHMMSS)는
 *     스코프체인으로 해소 → bare 유지. onclick 문자열(lastSetDodate)도 그대로.
 *   - 공유 blade 전역은 window.*(popWin/server_monst/server_monEndDate/
 *     timeTo_from/timeTo_until/popupOK).
 *
 * 진입점은 initialize() 가 8함수를 모두 window 로 브리지한다(블레이드 툴바 onclick +
 * __ordersPageBoot + /u/main 팝업의 opener 콜백 대비).
 */
import Util from '../../../Common/Util';

function calanderWinPop(n) {
    if (n != 22) return;
    var adr = "/u/main";
    window.popWin = window.open(adr, 'mainbuller', 'toolbar=no,status=no,WIDTH=1500,HEIGHT=900, directories=no,scrollbars=yes,location=no,resizable=yes,menubar=no');
    var n2 = (window.screen.availHeight / 2) - 600;
    var n1 = (window.screen.availWidth / 2) - 200;
    if (!window.popWin) {
        Util.swalert("달력 팝업이 차단되었습니다.\n차단을 허용해 주세요");
        return;
    }
    window.popWin.moveTo(n1, n2);
    window.popWin.focus();
}

function popUp_InitNoticeGet(val) {
    window.popupOK = val;
}

function popExistsCheck() {
}

function getDateValue(md, start, end) {
    if (md == 1) {
        if (start.length < 10) return;
        document.getElementById("start_date").value = start;
        document.getElementById("end_date").value = start;
        search();
    } else {
        if (start.length == 10) document.getElementById("start_date").value = start;
        if (end.length == 10) document.getElementById("end_date").value = end;
        if (start.length == 10 && end.length == 10) {
            search();
        }
    }
}

function getStatusofPopup(act) {
    var obj = document.getElementById("popupon");
    obj.value = act;
}

function setTimeToAll() {
    setTimeTo(null, window.server_monst, window.server_monEndDate, -1);
}

/**
 * 검색기간을 지정한다.
 */
function setTimeTo(tar, st, en, mth) {
    if (mth == -1) {
        document.getElementById("anyOptions").style.display = "none";
        document.getElementById("start_date").value = st;
        document.getElementById("end_date").value = en;
        search();
        return;
    }
    window.timeTo_from = st;
    window.timeTo_until = en;
    if (!tar) return;
    var mmm = "한달";
    if (mth == 2) mmm = "두달";
    if (mth == 3) mmm = "세달";

    var htm = "<input type='button' value='오늘기준 " + mmm + "' class='acBtn' style='width:100px;height:30px;' onclick='lastSetDodate(-1)'>&nbsp;&nbsp;";
    htm += "<input type='button' value='월기준 " + mmm + "' class='acBtn' style='width:100px;height:30px;' onclick='lastSetDodate(" + mth + ")'>";

    var rt = tar.getBoundingClientRect();
    var obj = document.getElementById("anyOptions");
    document.getElementById("anyOptionsCont").innerHTML = htm;
    obj.style.width = "300px";
    obj.style.paddingTop = "10px";
    obj.style.textAlign = "center";
    obj.style.top = rt.bottom + "px";
    obj.style.left = rt.left + "px";
    obj.style.display = "block";
}

function lastSetDodate(n) {
    if (n < 0) {
        setTimeTo(null, window.timeTo_from, window.timeTo_until, n)
        return;
    }
    var Ts = new Date(); Ts.setMonth(Ts.getMonth() - 1);
    var a = new Date();
    a.setMonth(a.getMonth() - n);
    // 예전엔 get_YYYYMMDDHHMMSS(a,"","__getone") 였다. 그 세번째 인자는 어느 분기에도
    // 없어서 결국 기본값(YYYY-MM-DD)으로 떨어지고 있었다.
    var b = dayjs(a).format('YYYY-MM-DD');
    var c = dayjs(Ts).format('YYYY-MM-DD');
    setTimeTo(null, b, c, -1);
}

/** 레거시 전역 호출처(블레이드 툴바 · __ordersPageBoot · /u/main 팝업 opener 콜백)에 window 브리지. */
export default class DateToolbar {
    calanderWinPop = calanderWinPop;
    popUp_InitNoticeGet = popUp_InitNoticeGet;
    popExistsCheck = popExistsCheck;
    getDateValue = getDateValue;
    getStatusofPopup = getStatusofPopup;
    setTimeToAll = setTimeToAll;
    setTimeTo = setTimeTo;
    lastSetDodate = lastSetDodate;
}
